// extracted by mini-css-extract-plugin
export default {"hoverable":"style_hoverable__EdsNU","menuIcon":"style_menuIcon__qiVSu"};